<template>
    <v-overlay :model-value="active" class="align-center justify-center">
        <v-progress-circular indeterminate size="64" />
    </v-overlay>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OverlayProgress extends Vue {
        @Prop({required: true}) active
    }

    export default OverlayProgress
</script>
